<template>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12">
            <b-form id="user_submit" @submit="onSubmit">
                <b-form-group label="ФИО"
                              label-for="name">
                    <b-form-input id="name"
                                  size="sm"
                                  type="text"
                                  v-model="user.item.name">
                    </b-form-input>
                    <span class=" alert-danger"
                          v-if="submitted && !user.item.name">Поле ФИО является обязательным.</span>
                </b-form-group>
                <b-form-group label="Email"
                              label-for="email">
                    <b-form-input id="email"
                                  size="sm"
                                  type="text"
                                  v-model="user.item.email">
                    </b-form-input>
                    <span class=" alert-danger"
                          v-if="submitted && !user.item.email">Поле Email является обязательным.</span>
                    <span class=" alert-danger" v-if="submitted && message">{{message}}</span>
                </b-form-group>
                <b-form-group label="Роль"
                              v-if="$currentUser.role == 'admin'"
                              label-for="role">
                    <b-form-select v-model="user.item.role"
                                   @change="changeRole"
                                   size="sm"
                                   class="filterComponent">
                        <option value="user">Пользователь</option>
                        <option value="leader">Лидер</option>
                        <option value="admin">Админ</option>
                        <option value="account">Аккаунт</option>
                    </b-form-select>
                    <span class=" alert-warning"
                          style="font-size: 10px;"
                          v-if="roleChanged">Пожалуйста, убедитесь, что действительно желаете поменять роль этого пользователя!</span>
                </b-form-group>

                <b-form-group label="Департамент"
                              label-for="department">
                    <b-form-select v-model="user.item.department"
                                   size="sm"
                                   class="filterComponent">
                        <option value="agency">Agency</option>
                        <option value="adkey">AdKey</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group v-if="$currentUser.role == 'admin' && user.item.role == 'leader'" label="Подчинённые"
                              label-for="users">
                    <v-select :options="availableUsers"
                              label="name"
                              required v-model="user.item.subordinates" multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                </b-form-group>
                <div class="row">
                    <div class="col-sm-6">
                        <b-form-group label="Network ID"
                                      label-for="name">
                            <b-form-input id="name"
                                          size="sm"
                                          type="number"
                                          v-model="user.item.network_partner_id">
                            </b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <b-form-group label="Market ID"
                                      label-for="name">
                            <b-form-input id="name"
                                          size="sm"
                                          type="number"
                                          v-model="user.item.market_partner_id">
                            </b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <div class="row" v-if="user.item.role == 'account'">
                    <div class="col-sm-6">
                        <b-form-group label="Affise Network API ID"
                                      label-for="name">
                            <b-form-input id="name"
                                          size="sm"
                                          type="text"
                                          v-model="user.item.network_user_id">
                            </b-form-input>
                            <span class=" alert-danger" v-if="submitted && network_user_id_message">{{network_user_id_message}}</span>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <b-form-group label="Affise Market API ID"
                                      label-for="name">
                            <b-form-input id="name"
                                          size="sm"
                                          type="text"
                                          v-model="user.item.market_user_id">
                            </b-form-input>
                            <span class=" alert-danger" v-if="submitted && market_user_id_message">{{market_user_id_message}}</span>
                        </b-form-group>
                    </div>
                </div>
                <b-form-group label="Пароль"
                              label-for="newPassword">
                    <b-form-input id="newPassword"
                                  size="sm"
                                  autocomplete="new-password"
                                  readonly
                                  onfocus="this.removeAttribute('readonly');"
                                  onblur="this.setAttribute('readonly','');"
                                  v-on:blur="validateNewPassword()"
                                  type="password"
                                  v-model="newPassword">
                    </b-form-input>
                    <span class=" alert-danger"
                          v-if="newPasswordMessage">{{newPasswordMessage}}</span>
                </b-form-group>
                <b-form-group label="Подтверждение пароля"
                              label-for="passwordRepeat">
                    <b-form-input id="passwordRepeat"
                                  size="sm"
                                  autocomplete="new-password"
                                  readonly
                                  onfocus="this.removeAttribute('readonly');"
                                  onblur="this.setAttribute('readonly','');"
                                  v-on:blur="validateRepeatPassword()"
                                  type="password"
                                  v-model="passwordRepeat">
                    </b-form-input>
                    <span class=" alert-danger"
                          v-if="repeatPasswordMessage">{{repeatPasswordMessage}}</span>
                </b-form-group>
                <b-form-checkbox v-model="user.item.deactivated"
                                 value="1"
                                 class="pb-3"
                                 unchecked-value="0" name="check-button">
                    Неактивен
                </b-form-checkbox>
                <b-form-checkbox v-model="user.item.is_hidden"
                                 value="1"
                                 class="pb-3"
                                 unchecked-value="0" name="check-button">
                    Скрыть пользователя
                </b-form-checkbox>

                <b-button type="submit" class="float-right"
                          variant="primary">Сохранить
                </b-button>
                <div class="form-errors"></div>
            </b-form>
        </div>
    </div>
</template>
<script>
    import UsersService from '../../../services/usersDataService'

    export default {
        name: 'EditUserModal',
        components: {
            UsersService: UsersService
        },
        props: {
            user: {
                default: function () {
                    return {
                        name: null,
                        email: null,
                        network_partner_id: null,
                        market_partner_id: null,
                        role: 'user',
                        department: null,
                        subordinates: [],
                        is_hidden: 0,
                        deactivated: 0,
                        newPassword: null
                    }
                }
            },
        },
        data() {
            return {
                availableUsers: [],
                submitted: false,
                message: null,
                network_user_id_message: null,
                market_user_id_message: null,
                roleChanged: false,
                newPassword: null,
                passwordRepeat: null,
                newPasswordMessage: null,
                repeatPasswordMessage: null,
                isNewPasswordIncorrect: false,
                isRepeatPasswordIncorrect: false
            }
        },
        methods: {
            onSubmit(evt) {
                evt.preventDefault();

                this.submitted = true;

                if (!this.user.item.name || !this.user.item.email) {
                    evt.preventDefault();

                    return;
                }

                if (!this.newPassword && !this.passwordRepeat) {
                    this.newPasswordMessage = null
                    this.repeatPasswordMessage = null
                }

                if (this.isNewPasswordIncorrect || this.isRepeatPasswordIncorrect) {
                    evt.preventDefault();

                    return;
                }

                this.user.item.newPassword = this.newPassword

                let subordinatesArray = [];

                if (this.user.item.subordinates && this.user.item.subordinates.length != 0) {
                    this.user.item.subordinates.forEach(function (subordinate) {
                        subordinatesArray.push(subordinate.id)
                    });
                } else {
                    subordinatesArray = null
                }

                UsersService.updateUser(this.user.item, subordinatesArray)
                    .then(function (response) {
                        if (response) {
                            if (response.error) {
                                switch (response.error) {
                                    case 'email exists':
                                        this.message = 'Данный Email используется другим пользователем.';
                                        break;
                                    case 'invalid email':
                                        this.message = 'Некорректный Email.';
                                        break;
                                    case 'incorrect domain':
                                        this.message = 'Email обязан принадлежать почтовому домену @zorka.mobi.';
                                        break;
                                    case 'network_user_id':
                                        this.network_user_id_message = 'Юзер с таким id существует.';
                                        break;
                                    case 'market_user_id':
                                        this.market_user_id_message = 'Юзер с таким id существует.';
                                        break;
                                    default:
                                        this.message = 'Произошла ошибка.';
                                        break;
                                }
                            } else {
                                window.location.href = '/users';
                            }
                        }
                    }.bind(this))
            },
            validateNewPassword() {
                this.isNewPasswordIncorrect = false

                if (this.newPassword && this.newPassword.length < 6) {
                    this.newPasswordMessage = 'Пароль должен содержать не менее 6-ти знаков.';
                    this.isNewPasswordIncorrect = true
                }

                if (this.passwordRepeat && !this.newPassword) {
                    this.newPasswordMessage = 'Введите новый пароль.';
                    this.isNewPasswordIncorrect = true
                }
                if (this.newPassword && this.newPassword.length >= 6) {
                    this.newPasswordMessage = null;
                }
            },
            validateRepeatPassword() {
                this.isRepeatPasswordIncorrect = false
                if (this.newPassword && !this.passwordRepeat) {
                    this.repeatPasswordMessage = 'Введите подтверждение нового пароля.';
                    this.isRepeatPasswordIncorrect = true
                }

                if (this.newPassword && this.passwordRepeat && this.newPassword !== this.passwordRepeat) {
                    this.repeatPasswordMessage = 'Не совпадает с новым паролем.';
                    this.isRepeatPasswordIncorrect = true
                }

                if (this.newPassword && this.passwordRepeat && this.newPassword === this.passwordRepeat) {
                    this.repeatPasswordMessage = null;
                }
            },
            getAvailableSubordinates() {
                UsersService.getAvailableSubordinates()
                    .then(users => {
                        let subordinatesArray = [];
                        users.forEach(function (subordinate) {
                            if (this.user.item.id != subordinate.id) {
                                subordinatesArray.push(subordinate)
                            }
                        }.bind(this));
                        this.availableUsers = subordinatesArray
                    })
            },
            changeRole() {
                this.roleChanged = true
            },
        },
        beforeMount() {
            this.getAvailableSubordinates()
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/front/modals/EditUserModal.vue